<template>
    <div class="badge" :class="classes">
        <slot></slot>
        <span v-if="badges.length" class="badge-container">
            <span class="badge-wrapper" :style="style">
                <template v-if="tooltip">
                    <CompassTooltip
                        v-for="badge in badges"
                        :key="badge.label"
                        :content="badge.label"
                        placement="bottom-start"
                    >
                        <span class="badge-item" :class="[`badge-item--${badge.id}`]">
                            {{ content }}
                        </span>
                    </CompassTooltip>
                </template>
                <template v-else>
                    <span
                        v-for="badge in badges"
                        :key="badge.label"
                        class="badge-item"
                        :class="[`${badge.bgcolor}-bkg`, badge.color]"
                    >
                        {{ content }}
                    </span>
                </template>
            </span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'Badge',
    props: {
        badges: {
            type: Array,
            required: true,
        },
        content: {
            required: false,
        },
        dot: Boolean,
        inline: Boolean,
        tooltip: Boolean,
        bottom: Boolean,
        left: Boolean,
    },
    computed: {
        /**
         * Return classes of badge element according to props
         */
        classes() {
            return {
                dot: this.dot,
                inline: this.inline,
            };
        },
        /**
         * Return the dynammic style of badge-wrapper element according to props
         */
        style() {
            if (this.inline) return {};
            return {
                bottom: !this.bottom ? `calc(100% - ${this.offset}px)` : 'auto',
                left: !this.left ? `calc(100% - ${this.offset}px)` : 'auto',
                right: this.left ? `calc(100% - ${this.offset}px)` : 'auto',
                top: this.bottom ? `calc(100% - ${this.offset}px)` : 'auto',
            };
        },
        /**
         * Return the offset to applied for good postion of badge
         */
        offset() {
            return this.dot ? 2 : 4;
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.badge {
    display: inline-block;
    line-height: 1;
    position: relative;

    &.dot {
        .badge-item {
            height: 8px;
            width: 8px;
            min-width: 0;
            border-radius: 4px;
            padding: 0;
            margin-right: 3px;
        }
    }
    &.inline {
        align-items: baseline;
        display: inline-flex;
        justify-content: center;
        .badge-container,
        .badge-wrapper {
            position: relative;
        }
        .badge-container {
            margin: 0 4px;
        }
    }

    .badge-container {
        flex: 0 1;
        height: 100%;
        width: 100%;
        left: 0px;
        top: 0px;
        pointer-events: none;
        position: absolute;
    }
    .badge-wrapper {
        display: inline-flex;
        position: absolute;
    }
    .badge-item {
        height: 20px;
        min-width: 20px;
        border-radius: 10px;
        display: inline-block;
        pointer-events: auto;
        color: $white;
        font-size: 12px;
        letter-spacing: 0;
        padding: 4px 6px;
        pointer-events: auto;
        text-align: center;
        text-indent: 0;
        top: auto;
        white-space: nowrap;

        background-color: var(--colors-component-background-information-tag-subtle-brand);
        border-color: var(--colors-component-border-tag-blue);
        color: var(--colors-component-text-tag-subtle-brand);

        &--contact {
            background-color: var(--colors-component-background-information-tag-subtle-teal);
            border-color: var(--colors-component-border-tag-teal);
            color: var(--colors-component-text-tag-subtle-teal);
        }

        &--client {
            background-color: var(--colors-component-background-information-tag-subtle-light-blue);
            border-color: var(--colors-component-border-tag-light-blue);
            color: var(--colors-component-text-tag-subtle-light-blue);
        }

        &--prospect {
            background-color: var(--colors-component-background-information-tag-subtle-purple);
            border-color: var(--colors-component-border-tag-purple);
            color: var(--colors-component-text-tag-subtle-purple);
        }

        &--supplier {
            background-color: var(--colors-component-background-information-tag-subtle-coral);
            border-color: var(--colors-component-border-tag-coral);
            color: var(--colors-component-text-tag-subtle-coral);
        }

        &--company {
            background-color: var(--colors-component-background-information-tag-subtle-brand);
            border-color: var(--colors-component-border-tag-blue);
            color: var(--colors-component-text-tag-subtle-brand);
        }

        &--individual {
            background-color: var(--colors-component-background-information-tag-subtle-orange);
            border-color: var(--colors-component-border-tag-orange);
            color: var(--colors-component-text-tag-subtle-orange);
        }

        &--archived {
            background-color: var(--colors-component-background-information-tag-subtle-gray);
            border-color: var(--colors-component-border-tag-gray);
            color: var(--colors-component-text-tag-subtle-gray);
        }

        &--reference {
            background-color: var(--colors-component-background-information-tag-stroked);
            border-color: var(--colors-common-border-default);
            color: var(--colors-component-text-tag-subtle-gray);
        }
    }
}
</style>
